import { BaseBean } from './BaseBean';
import { MetaBean } from './MetaBean';
import { UnidadOrganicaBean } from './UnidadOrganicaBean';

export class ResponsableMetaBean extends BaseBean {
  public id: number;
  public unidadOrganica:UnidadOrganicaBean;
  public meta:MetaBean;

  public entidad: UnidadOrganicaBean;
  public despacho: UnidadOrganicaBean;
  public direccionGeneral: UnidadOrganicaBean;
  public direccionLinea: UnidadOrganicaBean;
  public area: UnidadOrganicaBean;
}
